import { Component, EventEmitter, OnInit } from '@angular/core';
import { DropdownOption, DropdownConfig } from 'src/app/components/custom-dropdown/custom-dropdown.component';
import { FaqBuilder, InfoDropdown } from 'src/app/components/faq/faq.component';
import { FeatureType } from 'src/app/components/featured-plates/featured-plates.component';
import { SidebarFilterConfig, SidebarFilterGroup, SidebarFilter } from 'src/app/components/side-bar-filters/side-bar-filters.component';
import { StickyConfig, StickyLinkGroup, StickyLink } from 'src/app/components/sticky-tabs/sticky-tabs.component';
import { HttpLoadingResp } from 'src/app/models/httpLoadingResp';
import { Registration } from 'src/app/models/registration';
import { RegistrationService } from 'src/app/services/registration-service';
import { SearchReqResponse, SearchService } from 'src/app/services/search-service';
import { SearchFilters } from '../search-results-page/search-results-page.component';
import GlobalFaqs from "../../global-faqs";

export class NumberOneResults {
  public one_by_one: Registration[];
  public two_by_one: Registration[];
  public three_by_one: Registration[];
}

@Component({
  selector: 'pla-number-one-page',
  templateUrl: './number-one-page.component.html',
  styleUrls: ['./number-one-page.component.scss']
})
export class NumberOnePageComponent implements OnInit {

  public stickyLinkConfig: StickyConfig = new StickyConfig(
    [
      new StickyLinkGroup([
        new StickyLink('Single Letter Results', 'single-letter-results', true),
        new StickyLink('Two Letter Results', 'two-letter-results', false),
        new StickyLink('Three Letter Results', 'three-letter-results', false),
        new StickyLink('Q&As', 'faq', false),
      ].filter(x => x != null)),
    ],
    new EventEmitter<void>()
  );
  public termSorting: DropdownOption = new DropdownOption('HIGH-TO-LOW', 'Price High to Low');
  public mobileFilterToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
  public sortTrigger: EventEmitter<void> = new EventEmitter<void>();
  public filterChange: EventEmitter<SearchFilters> = new EventEmitter<SearchFilters>();
  public filterUpdate: EventEmitter<SidebarFilterConfig<any>> =
    new EventEmitter<SidebarFilterConfig<any>>();
  public sortDropdownConfig: DropdownConfig = new DropdownConfig('Sort By', 'swap_vert', [
    new DropdownOption('A-Z', 'A-Z'),
    new DropdownOption('Z-A', 'Z-A'),
    new DropdownOption('LOW-TO-HIGH', 'Price Low to High'),
    new DropdownOption('HIGH-TO-LOW', 'Price High to Low')
  ], {
    initialValue: this.termSorting
  });

  public searchFilters: SidebarFilterConfig<SearchFilters> = new SidebarFilterConfig<SearchFilters>(
    [
      new SidebarFilterGroup('Sort By', [
        new SidebarFilter('sort', 'Sort By', 'sortBy', {
          selectConfig: this.sortDropdownConfig
        })
      ], { visible: true, customClass: 'd-block d-lg-none' }),
    ], this.filterChange);

  public raFeatured = new FeatureType('Recently Added', 'recently-added');
  public one_results: HttpLoadingResp<SearchReqResponse> = new HttpLoadingResp(true, undefined);
  public two_results: HttpLoadingResp<SearchReqResponse> = new HttpLoadingResp(true, undefined);
  public three_results: HttpLoadingResp<SearchReqResponse> = new HttpLoadingResp(true, undefined);
  public faq: InfoDropdown[] = GlobalFaqs.GetFaqsByKey("Number One");

  constructor(
    private searchService: SearchService,
    private registrationService: RegistrationService
  ) {
    this.filterChange.subscribe((_: SearchFilters) => {
      this.TermSortChange(this.sortDropdownConfig.options.find(o => o.value === _.sortBy), "");
    });
  }

  ngOnInit(): void {
    this.Search();
  }


  private Search(): void {
    this.searchService.getNumber1((_: NumberOneResults) => {
      this.one_results.Update(false, new SearchReqResponse('1-number-1', this.registrationService.formatRegistrations(_.one_by_one)));
      this.two_results.Update(false, new SearchReqResponse('2-number-1', this.registrationService.formatRegistrations(_.two_by_one)));
      this.three_results.Update(false, new SearchReqResponse('3-number-1', this.registrationService.formatRegistrations(_.three_by_one)));

      this.filterUpdate.emit(this.searchFilters);
      this.TermSortChange(this.termSorting, "");
    })
  }

  public TermSortChange(e: DropdownOption, key: string): void {
    this.termSorting = e;
    if (this.termSorting.value === 'A-Z') {
      this.one_results.Update(false, new SearchReqResponse('1-number-1', this.one_results.data.registrations.sort((a, b) => a.registration.localeCompare(b.registration))));
      this.two_results.Update(false, new SearchReqResponse('2-number-1', this.two_results.data.registrations.sort((a, b) => a.registration.localeCompare(b.registration))));
      this.three_results.Update(false, new SearchReqResponse('3-number-1', this.three_results.data.registrations.sort((a, b) => a.registration.localeCompare(b.registration))));
    }
    else if (this.termSorting.value === 'Z-A') {
      this.one_results.Update(false, new SearchReqResponse('1-number-1', this.one_results.data.registrations.sort((a, b) => b.registration.localeCompare(a.registration))));
      this.two_results.Update(false, new SearchReqResponse('2-number-1', this.two_results.data.registrations.sort((a, b) => b.registration.localeCompare(a.registration))));
      this.three_results.Update(false, new SearchReqResponse('3-number-1', this.three_results.data.registrations.sort((a, b) => b.registration.localeCompare(a.registration))));
    }
    else if (this.termSorting.value === 'HIGH-TO-LOW') {
      this.one_results.Update(false, new SearchReqResponse('1-number-1', this.one_results.data.registrations.sort((a, b) => b.price - a.price)));
      this.two_results.Update(false, new SearchReqResponse('2-number-1', this.two_results.data.registrations.sort((a, b) => b.price - a.price)));
      this.three_results.Update(false, new SearchReqResponse('3-number-1', this.three_results.data.registrations.sort((a, b) => b.price - a.price)));
    }
    else if (this.termSorting.value === 'LOW-TO-HIGH') {
      this.one_results.Update(false, new SearchReqResponse('1-number-1', this.one_results.data.registrations.sort((a, b) => a.price - b.price)));
      this.two_results.Update(false, new SearchReqResponse('2-number-1', this.two_results.data.registrations.sort((a, b) => a.price - b.price)));
      this.three_results.Update(false, new SearchReqResponse('3-number-1', this.three_results.data.registrations.sort((a, b) => a.price - b.price)));
    }
  }
}
